<template>
  <div>
    <div class="c-app-new flex-row align-items-center d-sm-down-none">
      <CRow class="p-0">
  <CCol sm="3" class="p-0">
 <TheSidebar></TheSidebar></CCol>
  <CCol sm="6" class="p-0"> <CContainer style="display: flex; justify-content: center;margin-top:0px" class="p-0">
      <div class="container-box-custom center">
        <div class="text-left">
          <div class="card-custom-web-new">
            <br />
            <!-- REGISTER STUDENT -->
            <CCard v-if="this.regCard == true" class="custom-bg-color" style="height: 125px"> 
              <CRow>
                <span style="position: absolute;
                  width: 20px;
                  height: 20px;
                  top: 0px;
                  right: 0px;"
                  >
                  <img src="../assets/img/icon/x-circle-white.svg" @click="closeRegCard()" />
                </span> 
                <div style="width: 50%" class="float-left">
                  <h3
                    style="text-align: left"
                    class="sub-title-header ml-4 mt-1"
                  >
                    Register Student <br />
                    <label class="sub-title-card">
                      Enjoy the full experience of Pickiddo</label
                    >
                    <CButton
                      color="info"
                      class="custom-header-btn"
                      @click="GoToRegisterStudent()"
                    >
                      Register Student</CButton
                    >
                  </h3>
                </div>
                <div style="width: 50%" class="float-right">
                  <img
                    style="
                      max-width: 100%;
                      right: 0;
                      position: absolute;
                      bottom: 0;
                    "
                    src="../assets/img/icon/Parents-bro1.svg"
                  />
                </div>
              </CRow>
            </CCard>

            <!-- FIND TUTOR -->
            <CCard class="custom-bg-color-grey mt-3" style="height: 117px">
              <CRow>
                <div style="width: 50%;" class="float-left">
                  <h3
                    style="text-align: left;"
                    class="sub-title-header2 mt-1 ml-4 mb-2"
                  >
                    <strong>Find Tutor</strong><br />
                  </h3>
                  <label class="sub-title-card2 ml-4" style="margin-bottom: 10px;">
                    Looking for a new tutor?</label
                  >
                  <CButton class="custom-header-btn ml-4" @click="GoToClassType()">
                    Find Now</CButton
                  >
                  
                </div>
                <div style="width: 50%" class="float-right">
                  <img
                    style="
                      width: 130.81px;
                      height: 93.13px;
                      top: 20px;
                      right: 10px;
                      position: absolute;
                      bottom: 0;
                    "
                    src="../assets/img/icon/findTutorvector.svg"
                  />
                </div>
              </CRow>
            </CCard>

            <br />
            
            <!-- TUTOR OF THE MONTH -->
            <div class="float-left">
              <strong style="color: #000A2C; text-align: left; margin: 20px;" class="class-teach-name"> Tutor of the Month </strong>
            </div>
            <div class="float-right">
              <strong class="custom-text-viewall" style="margin: 20px;" @click="GoToAllToTM()">View All</strong>
            </div>
              
            <br />
            <div style="clear: both"></div>

            <hooper
              settings="hooperSettings"
              ref="hooper"
              :itemsToShow="2"
              pagination="yes"
              class="d-sm-flex d-md-none"
            >
              <slide
                v-for="rate in rating"
                :key="rate.id"
                :index="rate.id"
              >
                <CRow style="margin: 0px 20px;">
                  <div style="display: flex; margin-right: 15px;">
                    <CCard class="custom-card-advertise" style="margin-left: 0px; height: 150px;">
                      <div v-if="rate.profileImage == null">
                        <img
                          src="../assets/img/icon/icondefault.svg"
                          class="custom-bg-advetise"
                          @click="GoToFTTutorProfile(rate.userId)"
                          style="width: 170px; height: 150px;"
                        />
                      </div>
                      <div v-else>
                        <img
                          :src="rate.profileImage"
                          class="custom-bg-advetise"
                          @click="GoToFTTutorProfile(rate.userId)"
                          style="width: 170px; height: 150px;"
                        />
                      </div>
                      
                      <div class="bg-linear">
                        <h1 class="custom-text-adv ml-2"> {{ rate.teacherName}} </h1>
                        <span v-if="rate.achivementContent != 'No achivement'">
                          <label class="custom-label-text ml-2">
                            {{ rate.achivementContent }}
                          </label>
                        </span>
                        <span v-else>
                          <label class="custom-label-text ml-2" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 130px;...">
                            {{ rate.aboutTutor }}
                          </label>
                        </span>
                        
                        <br />
                        <img src="../assets/img/icon/iconstar.svg" class="ml-2" />
                        <label class="float-right custom-label-text mr-2 mt-1"> 
                          {{ rate.totalRating }} ratings
                        </label>
                      </div>
                    </CCard>
                  </div>
                </CRow>
            
              </slide>

              <hooper-navigation slot="hooper-addons"></hooper-navigation>
              <hooper-pagination slot="hooper-addons"></hooper-pagination>
            </hooper>

            <hooper
              settings="hooperSettings"
              ref="hooper"
              :itemsToShow="4"
              pagination="yes"
              class="d-sm-down-none"
            >
              <slide
                v-for="rate in rating"
                :key="rate.id"
                :index="rate.id"
              >
                <CRow style="margin: 0px 20px;">
                  <div style="display: flex; margin-right: 15px;">
                    <CCard class="custom-card-advertise" style="margin-left: 0px; height: 150px;;">
                      <div v-if="rate.profileImage == null">
                        <img
                          src="../assets/img/icon/icondefault.svg"
                          class="custom-bg-advetise"
                          @click="GoToFTTutorProfile(rate.userId)"
                          style="width: 170px; height: 150px;"
                        />
                      </div>
                      <div v-else>
                        <img
                          :src="rate.profileImage"
                          class="custom-bg-advetise"
                          @click="GoToFTTutorProfile(rate.userId)"
                          style="width: 170px; height: 150px;"
                        />
                      </div>
                      
                      <div class="bg-linear">
                        <h1 class="custom-text-adv ml-2"> {{ rate.teacherName}} </h1>
                        <span v-if="rate.achivementContent != 'No achivement'">
                          <label class="custom-label-text ml-2">
                            {{ rate.achivementContent }}
                          </label>
                        </span>
                        <span v-else>
                          <label class="custom-label-text ml-2" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 130px;...">
                            {{ rate.aboutTutor }}
                          </label>
                        </span>
                        
                        <br />
                        <img src="../assets/img/icon/iconstar.svg" class="ml-2" />
                        <label class="float-right custom-label-text mr-2 mt-1"> 
                          {{ rate.totalRating }} ratings
                        </label>
                      </div>
                    </CCard>
                  </div>
                </CRow>
            
              </slide>

              <hooper-navigation slot="hooper-addons"></hooper-navigation>
              <hooper-pagination slot="hooper-addons"></hooper-pagination>
            </hooper>

            <!-- PICKIDDO TV -->
            <CCard class="custom-bg-color-grey" style="height: 153px">
              <CRow>
                <div style="width: 50%" class="float-left">
                  <h3
                    style="text-align: left"
                    class="sub-title-header2 mt-1 ml-4 mb-2"
                  >
                    <strong>Pickiddo TV</strong><br />
                  </h3>
                  <label class="sub-title-card2 ml-4" style="margin-bottom: 40px;">
                    Effortless Access All Recorded Online Classes</label
                  >
                  
                  <CButton class="custom-header-btn ml-4" @click="GoToPickiddoTv()">
                    Watch Now</CButton
                  >
                  
                </div>
                <div style="width: 50%" class="float-right mt-3">
                  <img
                    style="
                      max-width: 100%;
                      right: 0;
                      position: absolute;
                      bottom: 0;
                    "
                    src="../assets/img/icon/pickiddotv.svg"
                  />
                </div>
              </CRow>
            </CCard>

            <!-- REFERRAL -->
            <CCard class="custom-bg-color-grey mt-3" style="height: 153px">
              <CRow>
                <div style="width: 50%" class="float-left">
                  <h3
                    style="text-align: left"
                    class="sub-title-header2 mt-1 ml-4 mb-2"
                  >
                    <strong> Referral Program!</strong><br />
                  </h3>
                  <label class="sub-title-card2 ml-4" style="margin-bottom: 20px;">
                    Refer your friends and family to use pickiddo and to
                    receive awesome rewards!</label
                  >
                  <CButton class="custom-header-btn ml-4" @click="GoToReferral()">
                    Refer Now</CButton
                  >
                  
                </div>
                <div style="width: 50%" class="float-right">
                  <img
                    style="
                      max-width: 100%;
                      right: 0;
                      position: absolute;
                      bottom: 0;
                    "
                    src="../assets/img/icon/referral.svg"
                  />
                </div>
              </CRow>
            </CCard>

            <!-- HOTPICK -->
            <div class="float-left ml-3 mt-3">
              <strong class="custom-text-hotpick ml-1">Hot Pick</strong>
            </div>
            <div class="float-right mr-3 mt-3">
              <strong class="custom-text-viewall mr-1" @click="GoToAllHotPick">View All</strong>
            </div>
            <br />
            <div style="clear: both"></div>

         

            <hooper
              settings="hooperSettings2"
              ref="hooper"
              :itemsToShow="2"
              pagination="yes"
              class="d-sm-flex d-md-none"
            >
              <slide
                v-for="(item, index) in news"
                :key="item.Id"
                :index="item.Id"
              >
                <CRow style="margin: 0px 20px;">
                  <div style="display: flex; margin-right: 15px;">
                    <CCard class="custom-card-advertise" style="margin-left: 0px; height: 150px;">
                      <a :href="GoToLink(index)">
                        <div class="text-center p-1">
                          <img
                            style="max-width: 100%; border-radius: 10px"
                            :src="getPic(index)"
                          />
                        </div>
                      </a>
                    </CCard>
                  </div>
                </CRow>
            
              </slide>

              <hooper-navigation slot="hooper-addons"></hooper-navigation>
              <hooper-pagination slot="hooper-addons"></hooper-pagination>
            </hooper>

            <hooper
              settings="hooperSettings2"
              ref="hooper"
              :itemsToShow="4"
              pagination="yes"
              class="d-sm-down-none"
            >
              <slide
                v-for="(item, index) in news"
                :key="item.Id"
                :index="item.Id"
              >
                <CRow style="margin: 0px 20px;">
                  <div style="display: flex; margin-right: 15px;">
                    <CCard class="custom-card-advertise" style="margin-left: 0px; height: 150px;">
                      <a :href="GoToLink(index)">
                        <div class="text-center p-1">
                          <img
                            style="max-width: 100%; border-radius: 10px"
                            :src="getPic(index)"
                          />
                        </div>
                      </a>
                    </CCard>
                  </div>
                </CRow>
            
              </slide>

              <hooper-navigation slot="hooper-addons"></hooper-navigation>
              <hooper-pagination slot="hooper-addons"></hooper-pagination>
            </hooper>

            <!-- REGISTER AS TUTOR -->
            <CCard class="custom-bg-color-grey mb-5" style="height: 153px">
              <CRow>
                <div style="width: 50%" class="float-left">
                  <h3
                    style="text-align: left"
                    class="sub-title-header2 mt-1 ml-4 mb-2"
                  >
                    <strong> Become a Tutor</strong><br />
                  </h3>
                  <label class="sub-title-card2 ml-4" style="margin-bottom: 20px;">
                    Are you a teacher? Become our tutor and gain more side
                    income!</label
                  >
                  <CButton class="custom-header-btn ml-4" @click="GoToBecomeATutor()">
                    Register Now</CButton
                  >
                  
                </div>
                <div style="width: 50%" class="float-right">
                  <img
                    style="
                      max-width: 100%;
                      right: 0;
                      position: absolute;
                      bottom: 0;
                    "
                    src="../assets/img/icon/becomeatutor.svg"
                  />
                </div>
              </CRow>
            </CCard>

            <br /><br />

            <MainlayoutBottom class="d-md-none d-lg-none"></MainlayoutBottom>
            <div style="clear: both"></div>
          </div>
        </div>
      </div>
    </CContainer></CCol>
    <CCol sm="3" class="p-0">
      <TheSidebarRight class="mt-3"></TheSidebarRight></CCol>
    </CRow>
  </div>
  
  <div class="c-app-new flex-row align-items-center d-md-none d-lg-none">
<CRow class="p-0"><CContainer style="display: flex; justify-content: center">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />

           
            <!-- REGISTER STUDENT -->
            <CCard v-if="this.regCard == true" class="custom-bg-color" style="height: 125px"> 
              <CRow>
                <span style="position: absolute;
                  width: 20px;
                  height: 20px;
                  top: 0px;
                  right: 0px;"
                  >
                  <img src="../assets/img/icon/x-circle-white.svg" @click="closeRegCard()" />
                </span> 
                <div style="width: 50%" class="float-left">
                  <h3
                    style="text-align: left"
                    class="sub-title-header ml-4 mt-1"
                  >
                    Register Student <br />
                    <label class="sub-title-card">
                      Enjoy the full experience of Pickiddo</label
                    >
                    <CButton
                      color="info"
                      class="custom-header-btn"
                      @click="GoToRegisterStudent()"
                    >
                      Register Student</CButton
                    >
                  </h3>
                </div>
                <div style="width: 50%" class="float-right">
                  <img
                    style="
                      max-width: 100%;
                      right: 0;
                      position: absolute;
                      bottom: 0;
                    "
                    src="../assets/img/icon/Parents-bro1.svg"
                  />
                </div>
              </CRow>
            </CCard>

            <!-- FIND TUTOR -->
            <CCard class="custom-bg-color-grey mt-3" style="height: 117px">
              <CRow>
                <div style="width: 50%;" class="float-left">
                  <h3
                    style="text-align: left;"
                    class="sub-title-header2 mt-1 ml-4 mb-2"
                  >
                    <strong>Find Tutor</strong><br />
                  </h3>
                  <label class="sub-title-card2 ml-4" style="margin-bottom: 10px;">
                    Looking for a new tutor?</label
                  >
                  <CButton class="custom-header-btn ml-4" @click="GoToClassType()">
                    Find Now</CButton
                  >
                  
                </div>
                <div style="width: 50%" class="float-right">
                  <img
                    style="
                      width: 130.81px;
                      height: 93.13px;
                      top: 20px;
                      right: 10px;
                      position: absolute;
                      bottom: 0;
                    "
                    src="../assets/img/icon/findTutorvector.svg"
                  />
                </div>
              </CRow>
            </CCard>

            <br />
            
            <!-- TUTOR OF THE MONTH -->
            <div class="float-left">
              <strong style="color: #000A2C; text-align: left; margin: 20px;" class="class-teach-name"> Tutor of the Month </strong>
            </div>
            <div class="float-right">
              <strong class="custom-text-viewall" style="margin: 20px;" @click="GoToAllToTM()">View All</strong>
            </div>
              
            <br />
            <div style="clear: both"></div>

            <hooper
              settings="hooperSettings"
              ref="hooper"
              :itemsToShow="2"
              pagination="yes"
              class="d-sm-flex d-md-none"
            >
              <slide
                v-for="rate in rating"
                :key="rate.id"
                :index="rate.id"
              >
                <CRow style="margin: 0px 20px;">
                  <div style="display: flex; margin-right: 15px;">
                    <CCard class="custom-card-advertise" style="margin-left: 0px; height: 150px;">
                      <div v-if="rate.profileImage == null">
                        <img
                          src="../assets/img/icon/icondefault.svg"
                          class="custom-bg-advetise"
                          @click="GoToFTTutorProfile(rate.userId)"
                          style="width: 170px; height: 150px;"
                        />
                      </div>
                      <div v-else>
                        <img
                          :src="rate.profileImage"
                          class="custom-bg-advetise"
                          @click="GoToFTTutorProfile(rate.userId)"
                          style="width: 170px; height: 150px;"
                        />
                      </div>
                      
                      <div class="bg-linear">
                        <h1 class="custom-text-adv ml-2"> {{ rate.teacherName}} </h1>
                        <span v-if="rate.achivementContent != 'No achivement'">
                          <label class="custom-label-text ml-2">
                            {{ rate.achivementContent }}
                          </label>
                        </span>
                        <span v-else>
                          <label class="custom-label-text ml-2" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 130px;...">
                            {{ rate.aboutTutor }}
                          </label>
                        </span>
                        
                        <br />
                        <img src="../assets/img/icon/iconstar.svg" class="ml-2" />
                        <label class="float-right custom-label-text mr-2 mt-1"> 
                          {{ rate.totalRating }} ratings
                        </label>
                      </div>
                    </CCard>
                  </div>
                </CRow>
            
              </slide>

              <hooper-navigation slot="hooper-addons"></hooper-navigation>
              <hooper-pagination slot="hooper-addons"></hooper-pagination>
            </hooper>

            <hooper
              settings="hooperSettings"
              ref="hooper"
              :itemsToShow="4"
              pagination="yes"
              class="d-sm-down-none"
            >
              <slide
                v-for="rate in rating"
                :key="rate.id"
                :index="rate.id"
              >
                <CRow style="margin: 0px 20px;">
                  <div style="display: flex; margin-right: 15px;">
                    <CCard class="custom-card-advertise" style="margin-left: 0px; height: 150px;;">
                      <div v-if="rate.profileImage == null">
                        <img
                          src="../assets/img/icon/icondefault.svg"
                          class="custom-bg-advetise"
                          @click="GoToFTTutorProfile(rate.userId)"
                          style="width: 170px; height: 150px;"
                        />
                      </div>
                      <div v-else>
                        <img
                          :src="rate.profileImage"
                          class="custom-bg-advetise"
                          @click="GoToFTTutorProfile(rate.userId)"
                          style="width: 170px; height: 150px;"
                        />
                      </div>
                      
                      <div class="bg-linear">
                        <h1 class="custom-text-adv ml-2"> {{ rate.teacherName}} </h1>
                        <span v-if="rate.achivementContent != 'No achivement'">
                          <label class="custom-label-text ml-2">
                            {{ rate.achivementContent }}
                          </label>
                        </span>
                        <span v-else>
                          <label class="custom-label-text ml-2" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 130px;...">
                            {{ rate.aboutTutor }}
                          </label>
                        </span>
                        
                        <br />
                        <img src="../assets/img/icon/iconstar.svg" class="ml-2" />
                        <label class="float-right custom-label-text mr-2 mt-1"> 
                          {{ rate.totalRating }} ratings
                        </label>
                      </div>
                    </CCard>
                  </div>
                </CRow>
            
              </slide>

              <hooper-navigation slot="hooper-addons"></hooper-navigation>
              <hooper-pagination slot="hooper-addons"></hooper-pagination>
            </hooper>

            <!-- PICKIDDO TV -->
            <CCard class="custom-bg-color-grey" style="height: 153px">
              <CRow>
                <div style="width: 50%" class="float-left">
                  <h3
                    style="text-align: left"
                    class="sub-title-header2 mt-1 ml-4 mb-2"
                  >
                    <strong>Pickiddo TV</strong><br />
                  </h3>
                  <label class="sub-title-card2 ml-4" style="margin-bottom: 40px;">
                    Effortless Access All Recorded Online Classes</label
                  >
                  
                  <CButton class="custom-header-btn ml-4" @click="GoToPickiddoTv()">
                    Watch Now</CButton
                  >
                  
                </div>
                <div style="width: 50%" class="float-right mt-3">
                  <img
                    style="
                      max-width: 100%;
                      right: 0;
                      position: absolute;
                      bottom: 0;
                    "
                    src="../assets/img/icon/pickiddotv.svg"
                  />
                </div>
              </CRow>
            </CCard>

            <!-- REFERRAL -->
            <CCard class="custom-bg-color-grey mt-3" style="height: 153px">
              <CRow>
                <div style="width: 50%" class="float-left">
                  <h3
                    style="text-align: left"
                    class="sub-title-header2 mt-1 ml-4 mb-2"
                  >
                    <strong> Referral Program!</strong><br />
                  </h3>
                  <label class="sub-title-card2 ml-4" style="margin-bottom: 20px;">
                    Refer your friends and family to use pickiddo and to
                    receive awesome rewards!</label
                  >
                  <CButton class="custom-header-btn ml-4" @click="GoToReferral()">
                    Refer Now</CButton
                  >
                  
                </div>
                <div style="width: 50%" class="float-right">
                  <img
                    style="
                      max-width: 100%;
                      right: 0;
                      position: absolute;
                      bottom: 0;
                    "
                    src="../assets/img/icon/referral.svg"
                  />
                </div>
              </CRow>
            </CCard>

            <!-- HOTPICK -->
            <div class="float-left ml-3 mt-3">
              <strong class="custom-text-hotpick ml-1">Hot Pick</strong>
            </div>
            <div class="float-right mr-3 mt-3">
              <strong class="custom-text-viewall mr-1" @click="GoToAllHotPick">View All</strong>
            </div>
            <br />
            <div style="clear: both"></div>

         

            <hooper
              settings="hooperSettings2"
              ref="hooper"
              :itemsToShow="2"
              pagination="yes"
              class="d-sm-flex d-md-none"
            >
              <slide
                v-for="(item, index) in news"
                :key="item.Id"
                :index="item.Id"
              >
                <CRow style="margin: 0px 20px;">
                  <div style="display: flex; margin-right: 15px;">
                    <CCard class="custom-card-advertise" style="margin-left: 0px; height: 150px;">
                      <a :href="GoToLink(index)">
                        <div class="text-center p-1">
                          <img
                            style="max-width: 100%; border-radius: 10px"
                            :src="getPic(index)"
                          />
                        </div>
                      </a>
                    </CCard>
                  </div>
                </CRow>
            
              </slide>

              <hooper-navigation slot="hooper-addons"></hooper-navigation>
              <hooper-pagination slot="hooper-addons"></hooper-pagination>
            </hooper>

            <hooper
              settings="hooperSettings2"
              ref="hooper"
              :itemsToShow="4"
              pagination="yes"
              class="d-sm-down-none"
            >
              <slide
                v-for="(item, index) in news"
                :key="item.Id"
                :index="item.Id"
              >
                <CRow style="margin: 0px 20px;">
                  <div style="display: flex; margin-right: 15px;">
                    <CCard class="custom-card-advertise" style="margin-left: 0px; height: 150px;">
                      <a :href="GoToLink(index)">
                        <div class="text-center p-1">
                          <img
                            style="max-width: 100%; border-radius: 10px"
                            :src="getPic(index)"
                          />
                        </div>
                      </a>
                    </CCard>
                  </div>
                </CRow>
            
              </slide>

              <hooper-navigation slot="hooper-addons"></hooper-navigation>
              <hooper-pagination slot="hooper-addons"></hooper-pagination>
            </hooper>

            <!-- REGISTER AS TUTOR -->
            <CCard class="custom-bg-color-grey mb-5" style="height: 153px">
              <CRow>
                <div style="width: 50%" class="float-left">
                  <h3
                    style="text-align: left"
                    class="sub-title-header2 mt-1 ml-4 mb-2"
                  >
                    <strong> Become a Tutor</strong><br />
                  </h3>
                  <label class="sub-title-card2 ml-4" style="margin-bottom: 20px;">
                    Are you a teacher? Become our tutor and gain more side
                    income!</label
                  >
                  <CButton class="custom-header-btn ml-4" @click="GoToBecomeATutor()">
                    Register Now</CButton
                  >
                  
                </div>
                <div style="width: 50%" class="float-right">
                  <img
                    style="
                      max-width: 100%;
                      right: 0;
                      position: absolute;
                      bottom: 0;
                    "
                    src="../assets/img/icon/becomeatutor.svg"
                  />
                </div>
              </CRow>
            </CCard>

            <br /><br />

            <MainlayoutBottom></MainlayoutBottom>
            <div style="clear: both"></div>
          </div>
        </div>
      </div>
    </CContainer>
</CRow>
</div>

    
    <div class="header-top d-md-none d-lg-none">
      <CRow>
        <span class="custom-header-profile">
          <img
            v-if="studentProfileAuthorize == ''"
            width="50px"
            height="50px"
            src="../assets/img/icon/icondefault.svg"
          />
          <img
            v-else
            width="50px"
            height="50px"
            :src="photoURL"
            style="border-radius: 50%; border: 5px solid #fff"
          />
        </span>
        <div style="text-align: left">
          <span>
            <span class="custom-user-title text-white"
              >Hello {{ user.name }}!</span
            >
            <label class="label-greeting text-white"
              >What do you want to do today? <br /><br />
              <span class="custom-credit">O credits</span></label
            >
          </span>
          <span>
            <img
              style="position: absolute; top: 0; right: 30px"
              src="../assets/img/icon/notification.svg"
              @click="GoToNotification()"
            />
          </span>
          <div style="clear: both"></div>
        </div>
      </CRow>
    </div>

    <div style="clear: both"></div>

    
  </div>
</template>


<script>
import Vue from "vue";
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination,
} from "hooper";

import MainlayoutBottom from "../containers/TheBottomCustom2.vue";
import TheSidebar from "../containers/TheCustomSidebar.vue";
import TheSidebarRight from "../containers/TheCustomSidebarRight.vue";


Vue.use(require("vue-moment"));
import moment from "moment";

import "hooper/dist/hooper.css";

export default {
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination,
    MainlayoutBottom,
    TheSidebar,
    TheSidebarRight
  },
  data: function () {
    return {
      user: {},
      studentProfileAuthorize: "",
      schedule: [],
      hooperSettings: {
        itemsToShow: 2,
        centerMode: true,
        breakpoints: {
          800: {
            centerMode: false,
          },
          1000: {
            pagination: "fraction",
          },
        },
      },
      hooperSettings2: {
        itemsToShow: 2,
        centerMode: true,
        breakpoints: {
          800: {
            centerMode: false,
          },
          1000: {
            pagination: "fraction",
          },
        },
      },
      childs: [],
      parent: [],
      news: [],
      rating: [],
      regCard: true,
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetAuthorizeProfile(this.user.id);
            this.GetListChild(this.user.id);
            this.GetParentDetail(this.user.id);
            this.GetNews();
            this.GetTutorRating();
          }
        });
    },

    GetAuthorizeProfile() {
      this.$API
        .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfileAuthorize = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.studentProfileAuthorize;
          }
        });
    },

    GetScheduleToday() {
      this.$API
        .get(this.$ScheduleStudentToday + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.schedule = response.data;
          }
        });
    },

    GetListChild() {
      this.$API
        .get(this.$ListChild + "?userID=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.childs = response.data;
          }
        });
    },

    GetParentDetail() {
      this.$API
        .get(this.$GetParentDetailByUserId + "?id=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.parent = response.data;
          }
        });
    },

    GetNews() {
      this.$API.get(this.$News, {}).then((response) => {
        if (response.status == 200 && response.data != null) {
          this.news = response.data;
          this.getPic(this.news.urlImage);
          this.GoToLink(this.news.Url);
        }
        console.log(this.news.Url)
      });
    },

    GetTutorRating() {
      this.$API
        .get(this.$GetTutorRatingLimitByCountryId + "?countryId=" + this.user.countryId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.rating = response.data;
          }
        });
    },

    GoToAllToTM() {
      this.$router.push("/FindTutor/AllTutorOfTheMonth");
    },

    GoToFTTutorProfile(userId) {
      this.$router.push("/FindTutor/FTTutorProfile?teacherId=" + userId);
    },

    GoToRegisterStudent() {
      this.$router.push("/RegisterStudent");
    },

    GoHome() {
      this.$router.push("/ExistingUser");
    },

    GoProfile() {
      if (this.user.userType == "parent") {
        this.$router.push("ParentProfile/Profile");
      } else {
        this.$router.push("TutorProfile");
      }
    },

    GoClass() {
      this.$router.push("/Class/ClassMain");
    },

    GoToNotification() {
      this.$router.push("/Notification");
    },

    GoToClassType() {
      this.$router.push("/FindTutor/FTClassType");
    },
    
    GoToBecomeATutor() {
      this.$router.push("/FindTutor/BecomeATutor");
    },

    GoToAllHotPick() {
      this.$router.push("/HotPick");
    },

    getPic(index) {
      return this.news[index].urlImage;
    },

    GoToLink(index) {
      return this.news[index].url;
    },
    GoToReferral()
    {
      this.$router.push("/Referral/Parent");
    },
    closeRegCard()
    {
      this.regCard = false;
    },
    GoToPickiddoTv()
    {
      window.open("https://tv.pickiddo.com/#/LoginPickiddo","_self");
    }
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: auto;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}

.hooper-pagination {
  display: none;
}
.hooper {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: auto;
}

.class-teach-name {
  padding: 4px 1px;
  top: 45px;
  /* height: 40px; */

  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;

  /* Pure/White */

  color: #FFFFFF;


  /* Inside auto layout */

  /* flex: none;
  order: 0;
  flex-grow: 0; */
}
</style>